import { RichTextEditor as AntdRichTextEditor } from "@empglabs/backoffice-ui-kit"

const RichTextEditor = props => {
  return <AntdRichTextEditor {...props} />
}

export default RichTextEditor
